/*
 * @Author: liuxw@codoon.com
 * @Date: 2020-10-31 17:17:38
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2022-06-29 16:37:49
 * @Content:
 */
import { find, map } from "lodash";
import React, { FC, memo, useCallback, useEffect, useState } from "react";
import { ISportType, ISportTypeInfo } from "../../interface";
import "./index.css";
import classnames from "classnames";
import { SPORT_TYPE_LABEL_MAP } from "../../const";
import { tempBtnColorSelecor } from "../../../store/common/selector";
import { connect } from "react-redux";

const PREFIX = "SportTypeSelector";

type IProps = {
  sportTypeInfos: ISportTypeInfo[];
  onClose: () => void;
} & ReturnType<typeof mapStateToProps>;

const SportTypeSelector: FC<IProps> = memo(
  ({ sportTypeInfos, onClose, tempBtnColor }) => {
    const [selectedSportType, setSelectedSportType] = useState<
      ISportType | undefined
    >(sportTypeInfos[0] ? sportTypeInfos[0].sportType : undefined);

    useEffect(() => {
      if (sportTypeInfos[0]) {
        setSelectedSportType(sportTypeInfos[0].sportType);
      }
    }, [sportTypeInfos]);

    // 选择运动类型
    const onSelectSportType = useCallback((sportTypeInfo: ISportTypeInfo) => {
      setSelectedSportType(sportTypeInfo.sportType);
    }, []);

    // 确认
    const onConfirm = useCallback(() => {
      const selectedSportTypeInfo = find(sportTypeInfos, (sportTypeInfo) => {
        return sportTypeInfo.sportType == selectedSportType;
      });
      if (selectedSportTypeInfo) {
        // 如果有选中项，则跳转
        window.open(selectedSportTypeInfo.jumpUrl, "_blank");
      }
      onClose();
    }, [selectedSportType, sportTypeInfos, onClose]);

    return (
      <div className={PREFIX}>
        <div className={`${PREFIX}-header`}>
          <div className={`${PREFIX}-headerBtn`} onClick={onClose}>
            取消
          </div>
          <div
            className={`${PREFIX}-headerBtn`}
            style={{ textAlign: "right" }}
            onClick={onConfirm}
          >
            确认
          </div>
        </div>
        <div className={`${PREFIX}-body`}>
          {map(sportTypeInfos, (sportTypeInfo) => {
            const isSelected = selectedSportType === sportTypeInfo.sportType;

            return (
              <div
                className={classnames(`${PREFIX}-bodyCard`, {
                  "is-selected": isSelected,
                })}
                onClick={() => {
                  onSelectSportType(sportTypeInfo);
                }}
                key={sportTypeInfo.sportType}
                style={
                  isSelected
                    ? {
                        color: tempBtnColor,
                      }
                    : {}
                }
              >
                {SPORT_TYPE_LABEL_MAP[sportTypeInfo.sportType]}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
);

const mapStateToProps = (state: any) => {
  return {
    tempBtnColor: tempBtnColorSelecor(state),
  };
};

export default connect(mapStateToProps)(SportTypeSelector);
